"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=3812%3A485))
 * @trackcomponent
 * @lastsynced 2023-08-15T21:03:21.471Z
 */
export const BulkSelect = createSVGIcon(
  <>
    <path
      d="M4.14307 4.20833V3C4.14307 1.89543 5.0385 1 6.14307 1H21.0002C22.1048 1 23.0002 1.89543 23.0002 3V17.8571C23.0002 18.9617 22.1048 19.8571 21.0002 19.8571H20"
      stroke="currentColor"
    />
    <rect
      x="1"
      y="4.14282"
      width="18.8571"
      height="18.8571"
      rx="2"
      stroke="currentColor"
    />
    <path
      d="M6.05127 14.6147L7.89253 16.9826C7.95447 17.0622 8.0335 17.1269 8.12377 17.1718C8.21405 17.2168 8.31328 17.2409 8.41412 17.2424C8.51497 17.2439 8.61486 17.2227 8.70643 17.1804C8.79799 17.1381 8.87889 17.0758 8.94315 16.9981L14.8064 9.90039"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "BulkSelect",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
